/**
 * Extract a user-friendly error message from a caught error.
 *
 * @param {Error|unknown} error - The caught error object.
 * @param {string} [methodName=''] - Optional method/context name appended when the message is generic.
 * @returns {string} A cleaned-up error message suitable for display.
 */
export const getErrorMessage = (error, methodName = '') => {
  let errorMessage = error.message || 'An error occurred while fetching data.';
  if (errorMessage.includes('Failed to parse JSON response. Response text:')) {
    errorMessage =
      errorMessage.split('Response text: ')[1]?.trim() ||
      'Something went wrong';
  }
  if (errorMessage === 'Something went wrong' && methodName) {
    errorMessage += ` in ${methodName}`;
  }
  return errorMessage;
};
